import axios from 'axios'
import { EventBus } from '@/../../shared/src/utils/eventbus.js'
import { getLcApiBase } from '@/../../shared/src/utils/constants.js'
import { delayCall } from '@/../../shared/src/utils.js'

axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = 'csrftoken'

let authToken = null
let apiGatewayAuthToken = null
let localLcConf = null
const validationInProgress = {
  'lcApi': false,
  'apiGateway': false
}

axios.interceptors.request.use(function (req) {
  // Add auth token to request object
  if (req.url && authToken && needsAuthToken(req.url)) {
    req.headers.common.Authorization = `Bearer ${authToken}`
  }
  if (req.url && apiGatewayAuthToken && needsApiGatewayAuthToken(req.url)) {
    req.headers.common['X-Lc-Security-Token'] = apiGatewayAuthToken
  }
  return req
}, function (err) {
  // Do something with request error
  return Promise.reject(err)
})

axios.interceptors.response.use(function (resp) {
  return resp
}, function (err) {

  // If the request is not authorised refresh the auth token and replay
  if (err.response && err.response.status === 401) {

    if (err.response.data && err.response.data.message === 'Unauthorized') {
      return handle401Failure('apiGateway', 'X-Lc-Security-Token', validateApiGatewayData, err.config)
    }

    if (err.response.data && err.response.data.error && err.response.data.error.message === 'Signature has expired.') {
      return handle401Failure('lcApi', 'Authorization', validateApiData, err.config)
    }
  }

  if (err && err.message && err.message === 'Network Error') {
    EventBus.$emit('NoNetworkError', err)
  }
  return Promise.reject(err)
})

export function validateApiGatewayData (conf = localLcConf) {

  const validateUrl = `${getLcApiBase(conf)}/validate-apigw/`

  return axios.post(validateUrl, conf, {'headers': {'Content-Type': 'application/json'}})
    .then((resp) => {
      apiGatewayAuthToken = resp.data.token
      localLcConf = conf
      return resp
    })
}

export function validateApiData (conf = localLcConf) {

  const validateUrl = (conf && conf.validateUrl) || `${getLcApiBase(conf)}/validate/`

  return axios.post(validateUrl, conf, {'headers': {'Content-Type': 'application/json'}})
    .then((resp) => {
      authToken = resp.data.token
      localLcConf = conf
      return resp
    })
}

export default axios

function needsAuthToken (url) {
  return url.indexOf(getLcApiBase(localLcConf)) > -1
}

function needsApiGatewayAuthToken (url) {
  return (url.indexOf('vcapi2.learncube.com') > -1 || url.indexOf('vcapi.learncube.com') > -1)
}

function handle401Failure (progressVar, headerName, validateCall, reqConfig) {
  delete reqConfig.headers[headerName]

  if (validationInProgress[progressVar]) {
    return delayCall(() => axios(reqConfig), 1500)
  } else {
    validationInProgress[progressVar] = true
    return validateCall().then(() => {
      validationInProgress[progressVar] = false
      return axios(reqConfig)
    })
  }
}
